import { ensureHeaderMicrofrontend } from '../../microfrontend';

export async function updateHeader(): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v3/update-header/');
}
